import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import { Loader } from 'semantic-ui-react';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import { ASSIGNMENT_MENU_STATUS } from '../managers/AssignmentManager';

const StudentCourseDrivenAssignments = observer((props = {}) => {
  const { t } = props;

  const {
    studentCourseDrivenExperienceManager
  } = useContext(MobXProviderContext);

  const loading = studentCourseDrivenExperienceManager.loadingStudentCourseDrivenExperience;

  const { selectedCourseDrivenAssignmentMenuStatus: selectedAssignmentMenuStatus } = studentCourseDrivenExperienceManager;

  const StudentAssignmentMenuStatusTabs = SatCoreComponent('StudentAssignmentMenuStatusTabs');
  const StudentCourseDrivenAssignmentsTable = SatCoreComponent('StudentCourseDrivenAssignmentsTable');

  const courseDrivenAssignmentsLabel = t('courseDrivenAssignmentsLabel');

  const handleChangeSelectedAssignmentMenuStatus = async (_event, data = {}) => {
    if (!loading && data.name && typeof props.handleChangeSelectedAssignmentMenuStatus === 'function') {
      await props.handleChangeSelectedAssignmentMenuStatus({
        assignmentMenuStatus: data.name
      });
    }
  };

  const renderCourseDrivenAssignmentContent = () => {
    if (selectedAssignmentMenuStatus === ASSIGNMENT_MENU_STATUS.GRADED && !loading) {
      return (
        <StudentCourseDrivenAssignmentsTable
          handlePresent={props.handlePresent}
          renderAssignmentCards={props.renderAssignmentCards} />
      );
    } else {
      return (
        <div className='w-content'>
          <div className='ui items scroller'>
            {!loading ? props.renderAssignmentCards?.() : <Loader active />}
          </div>
        </div>
      );
    }
  };

  return (
    <div aria-label={courseDrivenAssignmentsLabel}
      className='StudentCourseDrivenAssignments dashboard-widget student-dashboard-widget-assignments green'
      tabIndex={0}>
      <div className='w-title w-student-course-driven-assignments-header'>
        <h2 className='w-title-inner' tabIndex='0'>{t(courseDrivenAssignmentsLabel)}</h2>
        <StudentAssignmentMenuStatusTabs
          activeMenuStatus={selectedAssignmentMenuStatus}
          idPrefix='course-driven-assignment'
          loading={loading}
          loadingClassName='loading-student-assignment-menu'
          onClick={handleChangeSelectedAssignmentMenuStatus}
          tabPanelId='course-driven-assignment-panel' />

      </div>
      <div
        aria-labelledby={`course-driven-assignment-tab-${selectedAssignmentMenuStatus}`}
        id='course-driven-assignment-panel'
        role='tabpanel'>
        {renderCourseDrivenAssignmentContent()}
      </div>
    </div>
  );
});
export default StudentCourseDrivenAssignments;

SatCoreRegister('StudentCourseDrivenAssignments', StudentCourseDrivenAssignments);
